/** Battle-only CharacterInstance rows — must not appear in the owned roster UI. */
const EPHEMERAL_PVP_ROSTER_ORIGINS = new Set(['pvp_pick', 'pvp_bot'])

/**
 * Strip ephemeral PvP battle characters from a fetch-characters response before
 * mirroring into Redux or rendering the owned roster grid.
 */
export function filterEphemeralPvpRosterCharacters<T extends { origin?: string }>(
  characters: T[] | null | undefined,
): T[] {
  if (!Array.isArray(characters)) return []
  return characters.filter(
    (c) => !EPHEMERAL_PVP_ROSTER_ORIGINS.has(String(c?.origin ?? '')),
  )
}
